import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { ErrorResponseMessage } from './ErrorResponseMessage';

@Component({
  selector: 'app-error-modal',
  templateUrl: './error-modal.component.html',
  styleUrls: ['./error-modal.component.scss'],
  standalone: true,
  imports: [
    MatButtonModule, 
    MatDialogModule
  ]
})
export class ErrorModalComponent {

  constructor(@Inject(MAT_DIALOG_DATA) public data: ErrorResponseMessage) { }

}